// extracted by mini-css-extract-plugin
export var inner = "Intro__inner-OdGkF";
export var wrapper = "Intro__wrapper-v2njP";